var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#337FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5926 12.7496L14.9084 10.5789H12.9632V9.16789C12.9632 8.57434 13.2347 7.99435 14.1032 7.99435H15V6.14585C14.4777 6.05574 13.95 6.00699 13.4211 6C11.82 6 10.7747 7.04127 10.7747 8.92369V10.5789H9V12.7496H10.7747V18H12.9632V12.7496H14.5926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcn);
export default __webpack_public_path__ + "static/media/fb-icn.3ff34eeaeb8adfce83d64d2be0dbab5e.svg";
export { ForwardRef as ReactComponent };